module.exports = __webpack_public_path__ + "img/full4-min.fd5ec2f2.png";